import React from "react";
import { GetUserMailboxMessagesForEntityQuery } from "../../generated/graphql";
import { isoDateStringToHumanReadable } from "../../util/date/locale-date-format";
import { Panel } from "../ui/panel/panel";
import { PanelType } from "../ui/panel/panel-type";
import { formatContactDisplay } from "./unified-message";

type ReceivedMessage =
    GetUserMailboxMessagesForEntityQuery["getUserMailboxMessagesForEntity"][number];

interface Props {
    message: ReceivedMessage;
    onDismiss: () => void;
}

export const ReceivedMessageDetail: React.FC<Props> = props => {
    const { message, onDismiss } = props;

    const toRecipients = message.to
        .map(r => formatContactDisplay(r.contact.name, r.contact.email))
        .join(", ");

    const ccRecipients = message.cc
        .map(r => formatContactDisplay(r.contact.name, r.contact.email))
        .join(", ");

    const bccRecipients = message.bcc
        .map(r => formatContactDisplay(r.contact.name, r.contact.email))
        .join(", ");

    return (
        <Panel
            isOpen={true}
            isLightDismiss={true}
            onDismiss={onDismiss}
            type={PanelType.largeFixed}
            className="app-component"
            headerText="View Email">
            <div className="space-y-4">
                <div className="space-y-2">
                    <h2 className="text-lg">From</h2>
                    <div className="font-bold">
                        {formatContactDisplay(message.from?.name, message.from?.email)}
                    </div>
                </div>
                <div className="space-y-2">
                    <h2 className="text-lg">To</h2>
                    <div className="font-bold">{toRecipients}</div>
                </div>
                {ccRecipients ? (
                    <div className="space-y-2">
                        <h2 className="text-lg">CC</h2>
                        <div className="font-bold">{ccRecipients}</div>
                    </div>
                ) : null}
                {bccRecipients ? (
                    <div className="space-y-2">
                        <h2 className="text-lg">BCC</h2>
                        <div className="font-bold">{bccRecipients}</div>
                    </div>
                ) : null}
                <div className="space-y-2">
                    <h2 className="text-lg">Received</h2>
                    <div className="font-bold">
                        {isoDateStringToHumanReadable(message.receivedTimestamp)}
                    </div>
                </div>
                <div className="space-y-2">
                    <h2 className="text-lg">Subject</h2>
                    <div className="font-bold">{message.subject || "(No subject)"}</div>
                </div>
                {message.bodyPreview ? (
                    <div className="min-w-full rounded border border-gray-200 p-4 whitespace-pre-wrap">
                        {message.bodyPreview}
                    </div>
                ) : null}
            </div>
        </Panel>
    );
};
